import { render, staticRenderFns } from "./activityTab.vue?vue&type=template&id=df937116&scoped=true&"
import script from "./activityTab.vue?vue&type=script&lang=js&"
export * from "./activityTab.vue?vue&type=script&lang=js&"
import style0 from "./activityTab.vue?vue&type=style&index=0&id=df937116&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df937116",
  null
  
)

export default component.exports